/**
 * ReadOnlyBanner — shown across the dashboard when the subscription has lapsed.
 *
 * Purpose: tell a read-only publisher why actions are disabled and link them to
 *          pricing to resubscribe. Rendered by AppShell when useReadOnly() is true.
 *
 * Styled to match the login "pending approval / verified" notice panel
 * (surface-low box + border, theme-token based so it adapts to light/dark) for a
 * consistent notice treatment across auth and subscription gating.
 */
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

export function ReadOnlyBanner() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      className="mb-6 flex items-center justify-between gap-4 rounded-xl border border-[var(--border)] bg-[var(--color-surface-low)] p-4 text-sm leading-relaxed text-[var(--text-secondary)] animate-fadeUp"
    >
      <span>{t("readOnly.banner")}</span>
      <Link
        to="/pricing"
        className="shrink-0 font-semibold text-[var(--gold-text)] underline underline-offset-4 hover:opacity-80"
      >
        {t("readOnly.resubscribe")}
      </Link>
    </div>
  );
}
